import { render, staticRenderFns } from "./ProductoDelete.vue?vue&type=template&id=01c07101"
import script from "./ProductoDelete.vue?vue&type=script&lang=js"
export * from "./ProductoDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports